import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import CancelIcon from '@mui/icons-material/Cancel';
import { useUser } from "../../Context/UserContext";

// Import the background image (Adjust path as per your folder structure)
import mapBackground from '../../Images/farm.jpeg'; 

const StatusUpdateDashboard = () => {
  const navigate = useNavigate();
  const { authData, logout } = useUser();

  // Get status from context
  const status = authData?.production_center_status;

  // Determine content based on status
  const renderContent = () => {
    if (status === 'pending') {
      return (
        <>
          
          
          <Typography variant="h5" fontWeight={800} color="#ffffff" gutterBottom sx={{ letterSpacing: '-0.5px' }}>
            Application Under Review
          </Typography>
          
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3, fontSize: '1.1rem', lineHeight: 1.6 }}>
            Your production center registration is currently <b style={{ color: '#ffc022' }}>pending</b>.
            <br />
            Please wait for the officer's approval. You will be able to access the dashboard once approved.
          </Typography>
        </>
      );
    }

    if (status === 'rejected') {
      return (
        <>
           <Box sx={{ width: 80, height: 80, bgcolor: 'rgba(255, 82, 82, 0.2)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px' }}>
            <CancelIcon sx={{ fontSize: 50, color: '#ff5252' }} />
          </Box>

          <Typography variant="h5" fontWeight={800} color="#ffffff" gutterBottom sx={{ letterSpacing: '-0.5px' }}>
            Application Rejected
          </Typography>
          
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3, fontSize: '1.1rem', lineHeight: 1.6 }}>
            Unfortunately, your application has been <b style={{ color: '#ff5252' }}>rejected</b>.
            <br />
            Please contact the department head for further clarification or to re-submit your application.
          </Typography>

          <Button
            variant="outlined"
            size="large"
            onClick={() => { logout(); navigate('/login'); }}
            sx={{
              borderColor: '#ff5252',
              color: '#ff5252',
              fontWeight: 700,
              px: 5,
              '&:hover': { 
                borderColor: '#ff5252',
                bgcolor: 'rgba(255, 82, 82, 0.1)'
              }
            }}
          >
            Logout & Try Again
          </Button>
        </>
      );
    }

    // Fallback if status is something else
    return (
      <Typography variant="body1" color="text.secondary">
        Status unknown. Please contact support.
      </Typography>
    );
  };

  return (
    <Box 
      sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '92vh',
        width: "100%",
        backgroundImage: `url(${mapBackground})`, 
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed'
      }}
    >
      <Paper 
        elevation={12}
        sx={{ 
          textAlign: 'center', 
          p: { xs: 4, md: 6 }, 
          maxWidth: 650, 
          borderRadius: 4,
          border: '1px solid #e0e0e0',
          boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
          position: 'relative',
          overflow: 'hidden',
          zIndex: 1,
          backdropFilter: 'blur(17px)',
          background: "transparent"
        }}
      >
        {/* Decorative Top Border - Matches WelcomeDashboard */}
        <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, height: 6, bgcolor: '#ffc022' }} />

        {/* Logo - Matches WelcomeDashboard */}
        <Box 
          sx={{ 
            width: 100, 
            height: 100, 
            bgcolor: 'transparent', 
            borderRadius: '50%', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            margin: '0 auto 32px',
          }}
        >
          <img 
            src="/TN.png" 
            alt="Logo" 
            style={{ height: '100px', objectFit: 'contain', marginRight: '10px' }} 
          />
        </Box>
        
        {/* Dynamic Content based on Status */}
        {renderContent()}
      </Paper>
    </Box>
  );
};

export default StatusUpdateDashboard;